<template>
  <div>

    <h4>LISTA PARA PAGAR</h4>
    <table class="table">
      <tbody>
        <tr v-for="l in toPay" :key="l.id">
          <td>
            <app-checkbox :id="'cb' + l.id" v-model="l.toPay">
              {{ l.product_name }}</app-checkbox
            >
          </td>
          <td :class="{ 'text-success': l.maked }">
            {{ l.maked ? "Realizado" : "Pendiente" }}
            <br />
            <ToothPiece
              v-for="l1 in l.th_list"
              :key="l1"
              :piece="l1"
            ></ToothPiece>
          </td>
          <td class="text-right text-nowrap">
            <app-span-money
              :quantity="l.unit_price - l.amount_paid"
              :moneyCode="plan.money_code"
            ></app-span-money>
          </td>
        </tr>
        <tr>
          <th>TOTAL</th>
          <th></th>
          <th class="text-right">
            <app-span-money
              :quantity="total"
              :moneyCode="plan.money_code"
            ></app-span-money>
          </th>
        </tr>
      </tbody>
    </table>
    <div v-show="payNow">
      <div class="form-group">
        <label for>Metodo de Pago</label>
        <app-select-payment-method
          v-model="reg.payment_method_id"
        ></app-select-payment-method>
      </div>
      <app-checkbox v-model="show_pay_to_account" class="mb-3">
        Agregar dinero a cuenta
      </app-checkbox>
      <div class="form-group" v-show="show_pay_to_account">
        <app-input-money
          :quantity.sync="reg.pay_to_account"
          :moneyCode="plan.money_code"
          :byKeyPress="false"
          :selCurrDis="true"
        ></app-input-money>
      </div>
    </div>

    <app-checkbox v-model="show_adds" class="mb-3">Adicionales</app-checkbox>

    <template v-if="show_adds">
      <h4>ADICIONALES</h4>
      <template v-for="(l, i) in products">
        <div class="form-group" :key="i">
          <label for=""> {{ l }} </label>
          <app-input-money
            :quantity.sync="productPays[i]"
            :moneyCode="1"
          ></app-input-money>
        </div>
      </template>
    </template>

    <app-button-submit
      v-show="!sale_id"
      @click="save()"
      :disabled="sending"
      text="Registrar Operacion"
    >
      <i class="fas fa-money-bill"></i>
      Pagar
    </app-button-submit>
    <a
      v-show="sale_id"
      :href="backendUrl + '/print/store/sales-ticket/' + sale_id"
      class="btn btn-light"
    >
      <i class="fa fa-print"></i> Imprimir Ticket
    </a>
  </div>
</template>

<script>
import { DentalClinicService } from "../service";
import { round } from "lodash";
import ToothPiece from "../odontogram/ToothPiece";
import { mapState } from "vuex";

export default {
  components: {
    // SelectPaymentMethod,
    ToothPiece
  },
  data: () => ({
    reg: {},
    client_money: 0,
    payNow: 2,
    sale_id: undefined,
    backendUrl: process.env.VUE_APP_API_URL,
    productPays: {},
    sending: false,
    show_adds: false,
    show_pay_to_account: false,
  }),
  props: {
    details: {},
    plan: {}
  },
  computed: {
    ...mapState({
      products: (s) => s.config.dental.treatments.products_to_pay
    }),
    toPay() {
      return this.details.filter((x) => {
        return !x.paid_out;
      });
    },
    total() {
      let total = 0;
      this.details
        .filter((x) => x.toPay)
        .map((x) => {
          total += parseFloat(x.unit_price - x.amount_paid);
        });

      for (let it in this.productPays) {
        total += parseFloat(this.productPays[it]);
      }

      return this.payNow == 2 ? total - this.plan.payment : total;
    }
  },
  methods: {

    pf: (num) => {
      let val = round(num, 2);
      return val > 0 ? val : 0;
    },
    /**@public */
    show() {
      this.client_money = 1;
      this.reset();
    },

    reset() {
      this.reg = {};
      this.reg.payment_method_id = 1;
      this.payNow = 1;
      this.sale_id = undefined;
      this.sending = false;
    },
    save() {
      this.sending = true;
      let listToPay = this.details
        .filter((x) => x.toPay)
        .map((x) => {
          return {
            product_id: x.product_id,
            treatment_plan_detail_id: x.id
          };
        });

      this.reg.pay = this.total;
      if(this.reg.pay_to_account > 0) {
        this.reg.pay += parseFloat(this.reg.pay_to_account);
      }
      this.reg.pay_change = 0;

      DentalClinicService.letsToPayTPD({
        plan_id: this.plan.id,
        list: listToPay,
        ...this.reg,
        payNow: this.payNow,
        adds: this.productPays,
      })
        .then(
          (res) => {
            this.$emit("paidOut");
            this.sale_id = this.payNow ? res : undefined;
          },
          (err) => {
            this.$store.dispatch("showError", err.response.data.message);
          }
        )
        .finally(() => {
          this.sending = false;
        });
    }
  }
};
</script>

<style></style>
